import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';

function SentryRoomTagger() {
    const { roomId } = useParams();

    useEffect(() => {
        if (roomId) Sentry.setTag('roomId', roomId);
    }, [roomId]);

    return null;
}

export default SentryRoomTagger;
